import { Component, EventEmitter, Input, Output } from '@angular/core';

import { AgentInfo } from '@amfam/shared/models';

@Component({
  selector: 'app-agent-selector',
  templateUrl: './agent-selector.component.html',
  styleUrls: ['./agent-selector.component.scss'],
  standalone: false
})
export class AgentSelectorComponent {
  @Input() agents: AgentInfo[];
  @Input() primaryButtonName: string;
  @Input() secondaryButtonName: string;
  @Output() agentSelected = new EventEmitter<AgentInfo>();
  @Output() sendToAgent = new EventEmitter();
  @Output() cancel = new EventEmitter();
  selectedAgent: AgentInfo;

  onAgentSelected(agent: AgentInfo) {
    this.selectedAgent = agent;
    this.agentSelected.emit(agent);
  }
}
